import script from "./ClinicSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicSettings.vue?vue&type=script&setup=true&lang=js"

import "./ClinicSettings.vue?vue&type=style&index=0&id=5bc7dac8&lang=css"

const __exports__ = script;

export default __exports__